import { LogOut, Shield, ShieldCheck, Eye } from 'lucide-react';
import { useState } from 'react';
import { toast } from 'sonner';
import { Button } from '@/components/ui/Button';
import { useAuth } from './AuthContext';
import { ProfileDialog } from './ProfileDialog';

const roleMeta: Record<string, { label: string; icon: typeof Shield; className: string }> = {
  admin:   { label: 'Admin',  icon: ShieldCheck, className: 'bg-primary/10 text-primary' },
  editor:  { label: 'Editor', icon: Shield,      className: 'bg-emerald-500/10 text-emerald-600 dark:text-emerald-400' },
  viewer:  { label: 'Viewer', icon: Eye,         className: 'bg-muted text-muted-foreground' },
};

export function UserBadge() {
  const { user, logout } = useAuth();
  const [profileOpen, setProfileOpen] = useState(false);
  if (!user) return null;
  const meta = roleMeta[user.role] ?? roleMeta.viewer;
  const Icon = meta.icon;

  return (
    <div className="flex items-center gap-2">
      <button
        type="button"
        onClick={() => setProfileOpen(true)}
        className="hidden text-right text-xs leading-tight sm:block hover:opacity-80 transition-opacity cursor-pointer"
        title="Edit profile"
      >
        <div className="max-w-[160px] truncate font-medium text-foreground">
          {user.display_name || user.email}
        </div>
        <span className={`inline-flex items-center gap-1 rounded-sm px-1.5 py-0.5 text-[10px] font-medium ${meta.className}`}>
          <Icon className="h-3 w-3" />
          {meta.label}
        </span>
      </button>
      <Button
        variant="ghost"
        size="icon"
        aria-label="Sign out"
        title="Sign out"
        onClick={async () => {
          try { await logout(); toast.success('Signed out'); }
          catch (err) { toast.error('Sign-out failed', { description: err instanceof Error ? err.message : String(err) }); }
        }}
      >
        <LogOut className="h-4 w-4" />
      </Button>
      <ProfileDialog open={profileOpen} onOpenChange={setProfileOpen} />
    </div>
  );
}
